module.exports = __webpack_public_path__ + "static/alignedGrids-3ec925ad35a0ddaec85558ce7673a13b.gif";